import { useRef, useEffect, MutableRefObject } from "react";
import makeTrashable from "trashable";

type Trashable = ReturnType<typeof makeTrashable>;

const useTrashablePromises = () => {
  const promiseStore: MutableRefObject<Array<Trashable>> = useRef([]);
  const currentKey = useRef(-1);

  useEffect(
    () => () => {
      const keys: any[] = Object.keys(promiseStore.current);
      keys.forEach((k) => {
        promiseStore.current[k].trash();
      });
      promiseStore.current = [];
    },
    []
  );

  const addPromise = (promise: Trashable) => {
    currentKey.current += 1;
    promiseStore.current[currentKey.current] = promise;
    return currentKey.current;
  };

  const removePromise = (key: number) => {
    delete promiseStore.current[key];
  };

  function registerPromise(promise: Promise<any>) {
    const trashablePromise = makeTrashable(promise);
    const key = addPromise(trashablePromise);

    const handledPromise = trashablePromise
      .then((value: any) => {
        removePromise(key);
        return Promise.resolve(value);
      })
      .catch((error: any) => {
        removePromise(key);
        return Promise.reject(error);
      });

    return handledPromise;
  }

  return { registerPromise };
};

export default useTrashablePromises;
